import { Container, Row, Col, Carousel } from "react-bootstrap";
import sliderhyundai from "../../assets/img/slider/slider-hyundai.png";
import sliderford from "../../assets/img/slider/slider-ford.png";
import sliderfiat from "../../assets/img/slider/slider-fiat.png";
import sliderjeep from "../../assets/img/slider/slider-jeep.png";
import sliderpeugeot from "../../assets/img/slider/slider-peugeot.png";
import sliderhyundaimob from "../../assets/img/slider/mobile/slider-hyundai.png";
import sliderfordmob from "../../assets/img/slider/mobile/slider-ford.png";
import sliderfiatmob from "../../assets/img/slider/mobile/slider-fiat.png";
import sliderjeepmob from "../../assets/img/slider/mobile/slider-jeep.png";
import sliderpeugeotmob from "../../assets/img/slider/mobile/slider-peugeot.png";
import marcas from "../../assets/img/marcas.png";
import Formulario from "../Formulario/Formulario";

const Slider = () => {
  const sliders = [
    {
      desktop: [
        { slider: sliderhyundai },
        { slider: sliderford },
        { slider: sliderfiat },
        { slider: sliderjeep },
        { slider: sliderpeugeot },
      ],
      mobile: [
        { slider: sliderhyundaimob },
        { slider: sliderfordmob },
        { slider: sliderfiatmob },
        { slider: sliderjeepmob },
        { slider: sliderpeugeotmob },
      ],
    },
  ];

  return (
    <Container fluid>
      <Row>
        <Col md={12} xs={12} className="mx-auto p-0 m-0">
          <div className="mainContainer">
            <Container>
              <Row>
                <Col md={10} xs={12} className="mx-auto p-0 m-0">
                  <Row>
                    <Col md={6} xs={11} className="mx-auto">
                      <img src={marcas} alt="Marcas" className="img-fluid mt-md-0 mt-4" />

                      <div className="titlesMain pt-5 mt-md-5 mt-0 pb-md-0 pb-5">
                        <h1>Subite a tu nuevo 0km.</h1>
                        <h2>7 marcas líderes, en un solo lugar. </h2>
                        <h2>
                          <b>¡Antes de decidir, vení a Montironi!</b>
                        </h2>
                      </div>
                    </Col>
                    <Col md={6} xs={11} className="mx-auto">
                      <div className="formulario">
                        <Formulario />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="d-md-block d-none">
            <Carousel controls={false} indicators={false} interval={3000}>
              {sliders[0].desktop.map((item, index) => (
                <Carousel.Item key={index}>
                  <img className="d-block w-100" src={item.slider} alt="Montironi" />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel controls={false} indicators={false} interval={3000}>
              {sliders[0].mobile.map((item, index) => (
                <Carousel.Item key={index}>
                  <img className="d-block w-100" src={item.slider} alt="Montironi" />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Slider;

